import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import FileDownload from 'react-file-download';
import GroupsTable from './groups-table';
import { downloadGroup, downloadGroups, getGroups, removeGroup } from '../../../../actions/groups';
import PageTitle from '../../../common/page-title/index';
import GroupsNavigationHead from './groups-navigation-head';
import { history } from '../../../../store';
import RemoveGroupDialog from '../remove-group-dialog';
import ToastMessage from '../../../common/toast-message';
import { stringToSnakeCase } from '../../../../utils/commonFunctions';
import GroupsSearch from './groups-search';

class GroupsPage extends Component {
  state = {
    pageNumber: 1,
    removeable: null,
    name: '',
    dateFrom: '',
    dateTo: ''
  };

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateFrom: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateFrom: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ dateTo: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ dateTo: '' });
    }
  };

  handleClear = () => {
    this.setState({
      pageNumber: 1,
      removeable: null,
      name: '',
      dateFrom: '',
      dateTo: ''
    }, this.handleSearch);
  };

  handleSearch = () => {
    const { dispatch } = this.props;
    const {
      name, dateFrom, dateTo
    } = this.state;

    const {current_page: currentPage} = this.props.paging;

    dispatch(getGroups(currentPage, name, dateFrom, dateTo));
  };

  toastError = () => toast.error(<ToastMessage iconStyle="error" message="Cannot download export data"/>);

  handlePageChange = (page) => {
    this.setState({ pageNumber: page }, this.afterPageChange);
  };

  afterPageChange = () => {
    const { pageNumber } = this.state;

    this.props.dispatch(getGroups(pageNumber));
  };

  handleDownloadAll() {
    downloadGroups()
      .then((response) => {
        this.downloadCsv('groups', response.data);
      })
      .catch(this.toastError);
  }

  handleDownload(id, name) {
    downloadGroup(id)
      .then((response) => {
        this.downloadCsv(name, response.data);
      })
      .catch(this.toastError);
  }

  // eslint-disable-next-line class-methods-use-this
  formatFileName(groupName) {
    return `${stringToSnakeCase(groupName)}.csv`;
  }

  downloadCsv(groupName, data) {
    FileDownload(data, this.formatFileName(groupName));
  }

  componentWillMount() {
    const {dispatch} = this.props;
    const {current_page: currentPage} = this.props.paging;

    dispatch(getGroups(currentPage))
      .then(() => this.resetPage());
  }

  resetPage() {
    this.setState({
      pageNumber: 1
    });
  }

  handleRemove(id) {
    this.setState({removeable: id});
  }

  handleConfirmRemove(result) {
    const {dispatch} = this.props;
    const {removeable} = this.state;

    if (result && removeable) {
      dispatch(removeGroup(removeable))
        .then(() => {
          this.resetPopup();
          dispatch(getGroups(this.props.paging.current_page));
        });
    } else {
      this.resetPopup();
    }
  }

  resetPopup() {
    this.setState({removeable: null});
  }

  // eslint-disable-next-line class-methods-use-this
  handleNew() {
    history.push('/admin/groups/new');
  }

  render() {
    const {groups} = this.props;
    const {
      current_page: currentPage, per_page: perPage, total_count: totalCount, total_pages: totalPages,
    } = this.props.paging;
    const {
      removeable, dateFrom, dateTo, name
    } = this.state;

    return (
      <div className="container-fluid">
        <PageTitle>
          Groups
        </PageTitle>
        <GroupsSearch
          dateFromValue={dateFrom}
          dateToValue={dateTo}
          nameValue={name}
          onDateFromChange={this.handleDateFromChange}
          onDateToChange={this.handleDateToChange}
          onNameChange={this.handleNameChange}
          onSearch={this.handleSearch}
          onClear={this.handleClear}
        />

        <GroupsNavigationHead
          downloadAll={this.handleDownloadAll.bind(this)}
          handleNew={this.handleNew.bind(this)}
        />

        <GroupsTable
          currentPage={parseInt(currentPage)}
          download={this.handleDownload.bind(this)}
          groups={groups}
          handleRemove={this.handleRemove.bind(this)}
          onPageChange={this.handlePageChange.bind(this)}
          sizePerPage={parseInt(perPage)}
          total={totalCount}
          totalPages={totalPages}
        />

        {removeable && <RemoveGroupDialog onClose={this.handleConfirmRemove.bind(this)}/>}

      </div>
    );
  }
}

const mapStateToProps = state => ({
  groups: state.groups.groups,
  paging: state.groups.meta,
  loading: !state.groups.fetched && state.groups.fetching,
});

export default connect(mapStateToProps)(GroupsPage);



// WEBPACK FOOTER //
// ./src/components/admin/groups/list/groups-page.jsx